import { render, staticRenderFns } from "./cuota-personalizada-page.vue?vue&type=template&id=506326ce&scoped=true&"
import script from "./cuota-personalizada-page.vue?vue&type=script&lang=js&"
export * from "./cuota-personalizada-page.vue?vue&type=script&lang=js&"
import style0 from "./cuota-personalizada-page.vue?vue&type=style&index=0&id=506326ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506326ce",
  null
  
)

export default component.exports